// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_21620d3522--wrapper--g3ryI","notice":"_21620d3522--notice--hLFWo"};